import { render, staticRenderFns } from "./RadioSelectLink.vue?vue&type=template&id=5424da54&"
import script from "./RadioSelectLink.vue?vue&type=script&lang=js&"
export * from "./RadioSelectLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports